export const MOBILE_SIDEBAR_OPEN_EVENT = "mobile-sidebar-open";

export const openMobileSidebar = () => {
  window.dispatchEvent(new CustomEvent(MOBILE_SIDEBAR_OPEN_EVENT));
};
